<div class="field-height">
  <div class="ap-flex gap-2">
    @if (explanation().isInvalid()) {
      <div class="ap-field-validation-error">
        {{ 'editTaxResultList.emptyExplanationError' | translate }}
      </div>
    } @else {
      <div
        [style.maxHeight.rem]="10"
        class="flex-fill p-2 rounded-1 border border-1 text-body-secondary overflow-hidden">
        <h4 class="small text-black top-0">
          {{ 'upsertSecurity.explanation' | translate }}
        </h4>
        <div
          gstarInternalLinks
          class="overflow-auto viewer-editor"
          [style.height.px]="120"
          [innerHTML]="explanation().value() | blankLinks | safe: 'html'"></div>
      </div>
    }

    <ap-button
      btnType="text"
      icon="edit-outline"
      [disabled]="isDisabled()"
      [compact]="true"
      ap-tooltip
      tooltipContent="Text Editor"
      (onClick)="explanationEditorHandler()" />
  </div>
</div>
